enum PushAction {
	none = 0,
	openExternalBrowser = 1,
	openInternalBrowser = 2
}

export default PushAction;
